import React from "react";


const IndiaboatsFeedWidget = () => {
  return (
    <div className="ibfw-box">
      <iframe
        title="Indiaboats Facebook Feed"
        src="https://www.facebook.com/plugins/page.php?href=https://www.facebook.com/indiaboats.in&tabs=timeline&width=290&height=410&small_header=false&adapt_container_width=true&hide_cover=false&show_facepile=true"
        width="100%"
        height="410"
        style={{ border: "none", overflow: "hidden" }}
        scrolling="no"
        frameBorder="0"
        loading="lazy"
        allow="encrypted-media"
      />
    </div>
  );
};

export default IndiaboatsFeedWidget;